<template>
  <InPlayerVideoOverlay>
    <OverlayContent>
      <template slot="message">
        {{ $t('player.download-overlay.mobile.header') }}
      </template>
      <DownloadAppButton
        slot="content"
        :overlay="true"
        :tracker="getAnalyticPayload(e => e.player['overlay-download'].click.action, video.id)"
        @click="performAction({
          tracker: {
            label: 'download-in-app',
          } });"
      >
        {{ $t('player.download-overlay.mobile.install-cta') }}
      </DownloadAppButton>
    </OverlayContent>

    <FooterAction
      slot="footer"
      :tracker="getAnalyticPayload(e => e.player['overlay-download'].click.close, video.id)"
      @click="() => dismiss({ autoplay: true })"
    >
      {{ $t('cancel') }}
    </FooterAction>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import DownloadAppButton from '@/scripts/Components/Molecules/DownloadAppButton.vue';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import OverlayContent from '../components/OverlayContent.ts.vue';
import OverlayButton from '../components/OverlayButton.ts.vue';
import FooterAction from '../components/FooterAction.ts.vue';

export default VideoPlayerOverlayBase.extend({
  i18n: {
    en: {
      cancel: 'Cancel',
    },
    id: {
      cancel: 'Batalkan',
    },
    zh: {
      cancel: '取消',
    },
  },
  components: {
    InPlayerVideoOverlay,
    OverlayContent,
    OverlayButton,
    FooterAction,
    DownloadAppButton,
  },

  methods: {
    getAnalyticPayload,
  },
});
</script>
